export default __webpack_public_path__ + "static/media/quote-down-square.5ff8f367.svg";